import React, { useEffect, useMemo, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import { MenuItem, Select, Tabs, useMediaQuery } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { PolicyTabStyles } from "./PolicyTabStyles";
import Activity from "./Activity/Activity";
import Billing from "./Billing/Billing";
import { featuresCodes, name, policyTabsList } from "../../../constants/Constants";
import Claims from "./Claims/Claims";
import LienHolders from "./LienHolders/LienHolders";
import Coverages from "./Coverages/Coverages";
import Documents from "./Documents/Documents";
import VehiclesAndDrivers from "./VehiclesAnDrivers/VehiclesAndDrivers";
import { useAppSelector } from "../../../store/hooks";
import { RootState } from "../../../store/store";
import { isFeatureAvailable } from "../../../utils/Utility";
import Dwelling from "./Dwelling/Dwelling";
import { useLocation, useParams } from "react-router-dom";
import RelatedPolicies from "./RelatedPolicies/RelatedPolicies";
//import Property from "./Property/Property";
//import Liability from "./Liability/Liability";
import { useTranslation } from "react-i18next";
import CustomerDetailsNotes from "../../../Agents/CustomerDetailsNotes/CustomerDetailsNotes";
import RiskAndCoverage from "./RiskAndCoverage/RiskAndCoverage";
const PolicyTab = () => {
  const isMobile = useMediaQuery("(max-width:789px)");
  const location = useLocation();

  const pathArray = location.pathname.split("/");

  const [value, setValue] = useState<string>("");

  const { t } = useTranslation();

  const { features } = useAppSelector((state: RootState) => state.features);

  const tabComponents: { [key: string]: React.ComponentType<any> } = {
    lob_pa_policies_activity: Activity,
    lob_ho_policies_activity: Activity,
    lob_pu_policies_activity: Activity,
    lob_bop_policies_activity: Activity,
    lob_fo_policies_activity: Activity,
    lob_pa_policies_coverages: Coverages,
    lob_ho_policies_coverages: Coverages,
    lob_pu_policies_coverages: Coverages,
    lob_pa_policies_vehicles_and_drivers: VehiclesAndDrivers,
    lob_ho_policies_dwelling: Dwelling,
    lob_pu_policies_related_policies: RelatedPolicies,
    lob_pa_policies_policy_documents: Documents,
    lob_ho_policies_policy_documents: Documents,
    lob_pu_policies_policy_documents: Documents,
    lob_bop_policies_policy_documents: Documents,
    lob_fo_policies_policy_documents: Documents,
    lob_pa_policies_lienholders: LienHolders,
    lob_ho_policies_mortgagee: LienHolders,
    lob_pa_billing_billing_tab: Billing,
    lob_ho_billing_billing_tab: Billing,
    lob_pu_billing_billing_tab: Billing,
    lob_bop_billing_billing_tab: Billing,
    lob_fo_billing_billing_tab: Billing,
    lob_pa_claims_claims_tab: Claims,
    lob_ho_claims_claims_tab: Claims,
    lob_pu_claims_claims_tab: Claims,
    lob_bop_claims_claims_tab: Claims,
    lob_fo_claims_claims_tab: Claims,
    lob_bop_policies_risks_coverages: RiskAndCoverage,
    lob_fo_policies_risk_coverages: RiskAndCoverage,
   // lob_fo_policies_property_tab: Property,
    //lob_bop_policies_liability_tab: Liability,
    agent_notes_tab: CustomerDetailsNotes,
  };

  const { lobCode } = useParams();

  const tabOptions = useMemo(
    () =>
      policyTabsList.filter((tab) => {
        switch (tab.label) {
          case "Activity": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) && tab.lobCode === lobCode
            );
          }
          case "Notes": {
            return (
              pathArray[1] === "agent" &&
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              })
            );
          }
          case "Coverages": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) && tab.lobCode === lobCode
            );
          }
          case "Vehicles & Drivers": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) &&
              lobCode &&
              lobCode === "PA"
            );
          }
          case "Dwelling": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) &&
              lobCode &&
              lobCode === "HO"
            );
          }
          case "Documents": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) && tab.lobCode === lobCode
            );
          }
          case "Related Policies": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) &&
              lobCode &&
              lobCode === "PU"
            );
          }
          case "Lienholder": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) &&
              lobCode &&
              lobCode === "PA"
            );
          }
          case "Mortgagee": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) &&
              lobCode &&
              lobCode === "HO"
            );
          }
          case "Billing": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) && tab.lobCode === lobCode
            );
          }
          case "Claims": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) && tab.lobCode === lobCode
            );
          }
          case "Risk & Coverage": {
            return (
              isFeatureAvailable({
                featureCodes: [tab.code],
                features,
              }) && tab.lobCode === lobCode
            );
          }
          // case "Liability": {
          //   return (
          //     isFeatureAvailable({
          //       featureCodes: [tab.code],
          //       features,
          //     }) &&
          //     lobCode &&
          //     lobCode === "BOP"
          //   );
          // }          
          // case "Risk & Coverage": {
          //   return (
          //     isFeatureAvailable({
          //       featureCodes: [tab.code],
          //       features,
          //     }) &&
          //     lobCode &&
          //     (lobCode === "FO")
          //   );
          // }
          default:
            return true;
        }
      }),
    [features, lobCode]
  );

  const getComponent = (code: string) => {
    const ComponentItem = tabComponents[code];
    return ComponentItem ? (
      <ComponentItem />
    ) : (
      <Box>{t("Missing component for this tab")}</Box>
    );
  };

  useEffect(() => {
    if (tabOptions.length > 0) {
      setValue(tabOptions[0].code);
    }
  }, [tabOptions]);

  return (
    <Box 
      id="policytab_container"
      data-test-id="test-policytab_container"
      aria-label="Policy Tab Container"
      sx={PolicyTabStyles.PolicyTabsStyles}
    >
      {isMobile ? (
        <Box 
          id="policytab_mobile-container"
          data-test-id="test-policytab_mobile-container"
          aria-label="Policy Tab Mobile Container"
          sx={{ padding: "0px" }}
        >
          <Select
            id="policytab_mobile-select"
            data-test-id="test-policytab_mobile-select"
            aria-label="Policy Tab Selection"
            value={value}
            IconComponent={KeyboardArrowDownIcon}
            onChange={(event) => setValue(event.target.value)}
            sx={PolicyTabStyles.selectStyles}
          >
            {tabOptions.map((tab) => (
              <MenuItem
                id={`policytab_option-${tab.label}`}
                data-test-id={`test-policytab_option-${tab.label}`}
                aria-label={`${tab.label} Tab Option`}
                key={tab.code}
                value={tab.code}
                sx={PolicyTabStyles.menuStyles}
              >
                {t(tab.label)}
              </MenuItem>
            ))}
          </Select>
          <Box 
            id="policytab_mobile-content"
            data-test-id="test-policytab_mobile-content"
            aria-label="Policy Tab Mobile Content"
          >
            {getComponent(value)}
          </Box>
        </Box>
      ) : value ? (
        <Box 
          id="policytab_desktop-container"
          data-test-id="test-policytab_desktop-container"
          aria-label="Policy Tab Desktop Container"
        >
          <Tabs
            id="policytab_tabs"
            data-test-id="test-policytab_tabs"
            aria-label="Policy Tabs"
            sx={PolicyTabStyles.tabList}
            onChange={(e, value) => setValue(value)}
            value={value}
          >
            {tabOptions.map((tab) => (
              <Tab
                id={`policytab_tab-${tab.label}`}
                data-test-id={`test-policytab_tab-${tab.label}`}
                aria-label={`${tab.label} Tab`}
                key={tab.code}
                label={t(tab.label)}
                sx={PolicyTabStyles.tab}
                value={tab.code}
              />
            ))}
          </Tabs>
          <Box 
            id="policytab_content"
            data-test-id="test-policytab_content"
            aria-label="Policy Tab Content"
          >
            {getComponent(value)}
          </Box>
        </Box>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default PolicyTab;
